export const filterInputStartDate = (query,op) => {
  return { label: "Start Date", type: "date", query,op };
};
export const filterInputEndDate = (query,op) => {
    return { label: "End Date", type: "date", query,op };
  };
